import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#96945F',
  gradientStop2 = '#424224',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '22.96 8.54'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <g>
        <path
          opacity="0.9"
          d="M9.50027 15.6C9.23027 15.6 8.96027 15.5899 8.69027 15.5699C4.71027 15.2399 2.52024 11.5199 2.41024 8.0199C2.33024 5.4499 3.44028 2.26991 6.82028 1.77991C8.15028 1.58991 9.44028 1.48999 10.6403 1.48999C15.5903 1.48999 18.8503 3.10997 19.1503 5.71997C19.3803 7.73997 18.3802 10.3299 16.6002 12.3199C14.7102 14.4299 12.1903 15.6 9.50027 15.6Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M10.6401 1.97998C15.2401 1.97998 18.3901 3.4699 18.6501 5.7699C18.8601 7.6199 17.8901 10.12 16.2301 11.98C14.4301 13.99 12.0401 15.1 9.50008 15.1C9.25008 15.1 8.99006 15.0899 8.73006 15.0699C5.04006 14.7599 3.01006 11.2799 2.91006 7.99988C2.84006 5.62988 3.8401 2.7099 6.8901 2.2699C8.2001 2.0799 9.4601 1.97998 10.6401 1.97998ZM10.6401 0.97998C9.4301 0.97998 8.13008 1.07991 6.75008 1.27991C-0.589918 2.33991 0.700097 15.4099 8.6401 16.0699C8.9301 16.0899 9.22008 16.11 9.50008 16.11C16.0901 16.11 20.1001 9.62991 19.6501 5.65991C19.3201 2.75991 15.8601 0.97998 10.6401 0.97998Z"
          fill="#77370B"
        />
      </g>
      <g>
        <path
          opacity="0.9"
          d="M36.4201 15.6C33.7301 15.6 31.2102 14.4299 29.3102 12.3099C27.5302 10.3199 26.5302 7.72996 26.7602 5.70996C27.0602 3.09996 30.3202 1.47998 35.2702 1.47998C36.4702 1.47998 37.7602 1.5799 39.0902 1.7699C42.4702 2.2599 43.5802 5.43989 43.5002 8.00989C43.3902 11.5099 41.2001 15.2299 37.2201 15.5599C36.9601 15.5899 36.6901 15.6 36.4201 15.6Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M35.2801 1.97998C36.4601 1.97998 37.7201 2.0799 39.0301 2.2699C42.0901 2.7099 43.0901 5.63988 43.0101 7.99988C42.9101 11.2799 40.8801 14.7599 37.1901 15.0699C36.9301 15.0899 36.6701 15.1 36.4201 15.1C33.8801 15.1 31.4901 13.99 29.6901 11.98C28.0301 10.12 27.0601 7.6199 27.2701 5.7699C27.5301 3.4699 30.6701 1.97998 35.2801 1.97998ZM35.2801 0.97998C30.0601 0.97998 26.6001 2.7699 26.2701 5.6499C25.8201 9.6199 29.8301 16.1 36.4201 16.1C36.7001 16.1 36.9901 16.0899 37.2801 16.0599C45.2201 15.3999 46.5101 2.3299 39.1701 1.2699C37.7901 1.0799 36.4901 0.97998 35.2801 0.97998Z"
          fill="#77370B"
        />
      </g>
      <path
        d="M35.15 0.679932C30.6 0.679932 25.94 1.65999 22.96 1.73999C19.98 1.65999 15.32 0.679932 10.77 0.679932C2.01002 0.679932 0 3.04993 0 3.04993V5.7699C1.06 6.4799 1.96002 7.8999 1.96002 7.8999C1.96002 1.6299 7.77002 0.0199902 15.27 1.98999C22.21 3.80999 18.44 10.5299 18.44 10.5299C18.44 10.5299 20.59 8.25994 21.07 7.18994C21.54 6.12994 20.01 4.2299 20.01 3.3999C20.01 2.8199 21.67 2.56995 22.97 2.56995C24.27 2.56995 25.93 2.8199 25.93 3.3999C25.93 4.2299 24.39 6.11994 24.86 7.18994C25.33 8.24994 27.42 10.0299 27.42 10.0299C27.42 10.0299 24 3.54995 30.8 2.06995C38.38 0.429946 43.98 1.6299 43.98 7.8999C43.98 7.8999 44.86 6.4799 45.92 5.7699V3.04993C45.91 3.04993 43.9 0.679932 35.15 0.679932Z"
        fill="#77370B"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="10.7936"
          y1="1.12599"
          x2="10.7936"
          y2="13.7625"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.191" stopColor={gradientStop1} />
          <stop offset="0.9969" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="35.1256"
          y1="1.12598"
          x2="35.1256"
          y2="13.7625"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.191" stopColor={gradientStop1} />
          <stop offset="0.9969" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
